import Typography from "Components/CommonComponents/Typography";
import React, { useContext, useEffect, useState } from "react";
import "./index.css";
import {
  Col,
  Collapse,
  Row,
  Spinner,
  Tooltip,
  UncontrolledTooltip,
} from "reactstrap";
import MultinodePicker from "Components/CommonComponents/MultinodePicker";
import { IUserInfo } from "utilFunctions/CommonInterfaces/userInterface";
import { UserInfoContext } from "Context/CommonContext";
import {
  BASE_URL,
  COVERED_TOPIC_NODES,
} from "utilFunctions/Constants/urlConstants";
import useMasterContext from "Context/MasterContext";
import NotMarkedIcon from "Assets/Icons/NotMarkedIcon";
import ErrorIcon from "Assets/Icons/ErrorIcon";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import LeftArrow from "Assets/Icons/LeftArrow";
import UpArrowIcon from "Assets/Icons/UpArrowIcon";
import DownArrowIcon from "Assets/Icons/DownArrowIcon";
const phoniexErrorKeysArray = [
  "Event Name",
  "Branch",
  "Batch name",
  "Subject",
  "Class",
];
interface ICoveredSyllabusInfo {
  getTopicCovered: any;
  isPopupVisible?: any;
  setIsPopupVisible?: any;
  lectureDetail?: any;
  topicsCovered?: any;
  allTopicCovered?: any;
  getTopicLoader?: any;
  checkedTopicCovered?: any;
  setisPaneOpen?: any;
  setRefreshTable?: any;
  isEditableCovered?: any;
  setIsUpdatingSchedule?: any;
  togglePopover?: any;
  popupIndex?: any;
}
export function CoveredSyllabusView(props: ICoveredSyllabusInfo): JSX.Element {
  const {
    getTopicCovered,
    lectureDetail,
    allTopicCovered,
    getTopicLoader,
    checkedTopicCovered,
    setisPaneOpen,
    isEditableCovered,
    setIsUpdatingSchedule,
    togglePopover,
    popupIndex,
  } = props;
  const [topicsToBeCovered, setTopicsToBeCovered] = useState<any>(
    checkedTopicCovered ? checkedTopicCovered : []
  );
  const userInfo = useContext<IUserInfo>(UserInfoContext);
  const { masters } = useMasterContext();
  const [isOpen, setIsOpen] = useState<boolean>(true);
  const { screen }: any = useWindowSize();
  const toggle = () => setIsOpen(!isOpen);
  useEffect(() => {
    setTopicsToBeCovered(checkedTopicCovered);
  }, [checkedTopicCovered]);
  const handleEditTopicCovered = (item: any) => {
    setIsUpdatingSchedule(false);
    setisPaneOpen(true);
    togglePopover(popupIndex);
    const obj = {
      facultyId: userInfo?.employeeId,
      batchId: item?.batchId,
      lectureId: item?.batchTimeTableId,
      fetchMarkedOnly: false,
      syllabusShortCode: item?.syllabusList,
      courseId: item?.courseId,
    };
    getTopicCovered(BASE_URL + COVERED_TOPIC_NODES, obj);
  };
  return (
    <>
      <div className="d-flex flex-column gap-3 p-0 w-100 pt-3">
        <div
          className={
            ["xs", "sm", "md"].includes(screen)
              ? "d-flex w-100 justify-content-between align-items-center pl-2 pr-2"
              : "d-flex w-100 justify-content-between align-items-center"
          }
        >
          <div className="d-flex align-items-center">
            <LeftArrow
              className={"cursorHoverCSS mr-2"}
              onClick={togglePopover}
            />
            <Typography
              variant={["xxl", "xl", "lg"].includes(screen) ? "h4" : "h6"}
              color="black"
            >
              {lectureDetail?.eventName}
            </Typography>
          </div>
          <div onClick={toggle}>
            {isOpen ? <UpArrowIcon /> : <DownArrowIcon />}
          </div>
        </div>
        <Collapse isOpen={isOpen} className="">
          <Row className="w-100 p-0 m-0">
            <Col
              sm={3}
              md={3}
              className={["xs", "sm", "md"].includes(screen) ? "lecCol" : ""}
            >
              <RenderItem
                label={"Event Name"}
                value={lectureDetail?.eventName}
                masters={masters}
              />
            </Col>
            <Col
              sm={3}
              md={3}
              className={["xs", "sm", "md"].includes(screen) ? "lecCol" : ""}
            >
              <RenderItem
                label={"Class"}
                value={lectureDetail?.class}
                masters={masters}
              />
            </Col>
            <Col
              sm={6}
              md={6}
              className={["xs", "sm", "md"].includes(screen) ? "lecCol" : ""}
            >
              <RenderItem
                label={"Branch"}
                value={lectureDetail?.branchId}
                masters={masters}
              />
            </Col>
          </Row>
          <Row className="w-100 p-0 m-0">
            <Col
              sm={3}
              md={3}
              className={["xs", "sm", "md"].includes(screen) ? "lecCol" : ""}
            >
              <RenderItem
                label={"Subject"}
                value={
                  lectureDetail?.subject
                    ? lectureDetail.subject.charAt(0).toUpperCase() +
                      lectureDetail.subject.slice(1).toLowerCase()
                    : ""
                }
                masters={masters}
              />
            </Col>
            <Col
              sm={3}
              md={3}
              className={["xs", "sm", "md"].includes(screen) ? "lecCol" : ""}
            >
              <RenderItem
                label={"Room"}
                value={lectureDetail?.room}
                masters={masters}
              />
            </Col>
            <Col
              sm={6}
              md={6}
              className={["xs", "sm", "md"].includes(screen) ? "lecCol" : ""}
            >
              <RenderItem
                label={"Batch name"}
                value={lectureDetail?.batchName}
                masters={masters}
              />
            </Col>
          </Row>
        </Collapse>
        <Row className="w-100 p-0 m-0">
          <Col sm={12} md={12}>
            {isEditableCovered ? (
              <>
                <div className="w-100 d-flex justify-content-between mt-3 mb-3">
                  <Typography variant="h5" color="black">
                    {lectureDetail.syllabusStatus == "Upcoming"
                      ? "Topics to be covered"
                      : lectureDetail.syllabusStatus == "Not Marked"
                      ? "Prescribed topics"
                      : "Topics covered"}
                  </Typography>
                  {lectureDetail.syllabusStatus != "Upcoming" && (
                    <>
                      <NotMarkedIcon
                        className="notmarkedIconStyle"
                        id="notmarkedtooltip"
                        data-toggle="tooltip"
                        data-trigger="hover"
                        onClick={(e: any) => {
                          e.preventDefault();
                          handleEditTopicCovered(lectureDetail);
                        }}
                      />
                      <UncontrolledTooltip
                        trigger="hover"
                        placement="left"
                        target={"notmarkedtooltip"}
                      >
                        Mark syllabus
                      </UncontrolledTooltip>
                    </>
                  )}
                </div>
                {getTopicLoader ? (
                  <div className="d-flex justify-content-center align-items-center w-100">
                    <Spinner color="info"></Spinner>
                  </div>
                ) : (
                  <MultinodePicker
                    popOver={true}
                    checkedKeysList={topicsToBeCovered}
                    setSelectedNodes={setTopicsToBeCovered}
                    nodes={allTopicCovered}
                    isDisabled={false}
                  ></MultinodePicker>
                )}
              </>
            ) : null}
          </Col>
        </Row>
      </div>
    </>
  );
}

interface IRenderItem {
  name?: string;
  label: string;
  value: string;
  masters?: any;
}

export function RenderItem(props: IRenderItem): JSX.Element {
  const { label, value, masters } = props;
  const { branches } = masters;
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const toggle = () => setTooltipOpen(!tooltipOpen);
  const getBranchName = (label: any, branches: any) => {
    const filteredArray = branches.filter((item: any) => item.key == label);
    const retLabel =
      filteredArray && Array.isArray(filteredArray) && filteredArray.length > 0
        ? filteredArray[0].label
        : undefined;
    return retLabel;
  };
  return (
    <div className="d-flex flex-column capitalize">
      <Typography variant="label" color="black">
        {label}
      </Typography>
      <Typography variant="h5" color="black">
        {label == "Branch" ? (
          getBranchName(value, branches) === undefined ? (
            <>
              <div className="cursorHoverCSS">
                <Tooltip
                  isOpen={tooltipOpen}
                  target="TooltipExample"
                  toggle={toggle}
                >
                  Phoneix Error
                </Tooltip>
                <div id="TooltipExample" style={{ width: "15px" }}>
                  <ErrorIcon />
                </div>
              </div>
            </>
          ) : (
            getBranchName(value, branches)
          )
        ) : value === undefined && phoniexErrorKeysArray.includes(label) ? (
          <div className="cursorHoverCSS">
            <Tooltip
              isOpen={tooltipOpen}
              target="TooltipExample"
              toggle={toggle}
            >
              Phoneix Error
            </Tooltip>
            <div id="TooltipExample" style={{ width: "15px" }}>
              <ErrorIcon />
            </div>
          </div>
        ) : (
          value
        )}
      </Typography>
    </div>
  );
}
